<template>
  <!-- Figma UQ "Equipment Info - Step 2": pink pill on the card's top edge, white 13px text -->
  <div class="py-[8px] px-[15px] rounded-[10px] bg-[#FC819E] shadow-[0px_0px_10px_-2px_rgba(0,0,0,0.15)]">
    <p class="mb-0 text-center text-[12px] laptop:text-[13px] font-roboto text-[#fff]">
      ***If a replacement is recommended, call
      <a class="no-underline text-[#fff] whitespace-nowrap" :href="'tel:' + getNumber()">{{ getFormatedNumber() }}</a>
      for pre-authorization***
    </p>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
    computed: {
    ...mapGetters([
      "quoteDetail",
    ]),
  },
  methods: {

    numberClicked(){
        
    },

    getNumber(){
        if (this.quoteDetail 
        && this.quoteDetail.partner_info
        && this.quoteDetail.partner_info.status == '1'
        && this.quoteDetail.partner_info.replacement_opportunity_number.length > 0) {


        return this.quoteDetail.partner_info.replacement_opportunity_number
      } else {
        return ""
      }
    },

    getFormatedNumber(){
        if (this.quoteDetail 
        && this.quoteDetail.partner_info
        && this.quoteDetail.partner_info.status == '1'
        && this.quoteDetail.partner_info.replacement_opportunity_number.length > 0) {
            let number = this.quoteDetail.partner_info.replacement_opportunity_number
            // drop the +1 country code (a US area code never starts with 1) before formatting (QA D-37)
            const digits = String(number).replace(/\D/g, '').replace(/^1/, '')
            return digits.length === 10 ? digits.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : number;
      } else {
            return ""
      }
    }
  }
}
</script>
